module.exports = __webpack_public_path__ + "img/pda.dc99c2f7.png";